import { Button, Icon, Spinner } from '@acpaas-ui/react-components';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getDossierAttachmentLink } from '../../lib/dossier.utils';
import LinkButton from '../core/LinkButton';

const AttachmentsList = ({
  className = '',
  title = '',
  attachments = [],
  loading,
  noAttachmentsText = 'Er zijn momenteel nog geen bijlagen toegevoegd.',
  templates,
  dossierId,
  asDownloadLink,
  labelOnly,
  nativeInputUpload,
  acceptedFileFormat = '*',
  onOpen = _.noop,
  onUpload
}) => {
  const onFileSelect = (event) => {
    onUpload && onUpload(event.target.files);
  };

  const renderListContent = () => {
    if (loading) {
      return (
        <li className="spo-o-attachments-list__list-item u-flex-justify-center">
          <Spinner size="large" />
        </li>
      );
    }

    if (!attachments?.length) {
      return (
        <li className="spo-o-attachments-list__list-item u-text-light">
          {noAttachmentsText}{' '}
          {onUpload && (
            <LinkButton className="u-margin-left-xs" disabled={loading} onClick={onUpload}>
              Toevoegen
            </LinkButton>
          )}
        </li>
      );
    }

    return attachments?.map((att) => (
      <li key={att.id} className={`spo-o-attachments-list__list-item ${labelOnly ? '' : 'u-text-primary'}`}>
        {!labelOnly && <Icon name="ai-download-bottom" className="u-margin-right-xs" />}
        <div>
          {labelOnly ? (
            att.name || att.url || att.fileName || ''
          ) : asDownloadLink ? (
            <a href={att.url || getDossierAttachmentLink(dossierId, att)} rel="noreferrer" target="_blank">
              {att.name || att.url || att.fileName || ''}
            </a>
          ) : (
            <LinkButton onClick={() => onOpen(att)}>{att.name || att.url || att.fileName || ''}</LinkButton>
          )}
          <p className="u-text-light">{att.description || ''}</p>
        </div>
      </li>
    ));
  };

  return (
    <div className={`spo-o-attachments-list ${className}`}>
      <div className="spo-o-attachments-list__header u-margin-bottom-xs">
        {title && <span className="u-text-bold">{title}</span>}
        <div className="spo-o-attachments-list__header-actions u-flex">
          {templates}
          {onUpload && (
            <div className="u-relative">
              <Button
                className="u-margin-left-sm"
                size="tiny"
                iconRight="ai-upload-bottom"
                disabled={loading}
                onClick={nativeInputUpload ? undefined : onUpload}
              >
                Bestand toevoegen
              </Button>
              {nativeInputUpload && (
                <input
                  id="upload"
                  type="file"
                  disabled={loading}
                  accept={acceptedFileFormat}
                  onChange={onFileSelect}
                  className="m-upload__input"
                />
              )}
            </div>
          )}
        </div>
      </div>
      <ul className="spo-o-attachments-list__list">{renderListContent()}</ul>
    </div>
  );
};

AttachmentsList.propTypes = {
  title: PropTypes.string,
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      description: PropTypes.string
    })
  ),
  templates: PropTypes.node,
  onOpen: PropTypes.func,
  onUpload: PropTypes.func
};
export default AttachmentsList;
